import { createContext, useContext } from 'react'
import type { Viewport } from './types'

// The device breakpoint currently being previewed/edited in the designer.
// Driven by the toolbar DeviceToggle. A single piece of state does double
// duty (WordPress-style): it sizes the canvas, selects which style layer
// the canvas resolves for display, AND selects which layer the style/size
// property editors read & write. Default 'desktop' so any consumer
// rendered outside the provider behaves as the base layer.
export const ViewportContext = createContext<Viewport>('desktop')

export function useViewport(): Viewport {
  return useContext(ViewportContext)
}
